// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detMain .textarea textarea{width:100%!important}.detMain .el-tabs__nav-scroll{height:42px;background:#f8f8f8;border:1px solid #e6e6e6}.detMain .el-tabs__item{height:44px;background:none;border:0;line-height:44px}.detMain .el-tabs__item .is-active{color:#fff!important;border-top:0;background-color:#0082f0}.el-tabs__item:hover{color:#0082f0!important}.detMain #tab-first{border-left:0}.el-tabs__nav-wrap:after{height:0!important}.el-tabs__header{margin:0!important}", ""]);
// Exports
module.exports = exports;
